import InactivityWarningDialog from "./InactivityWarningDialog";

export default InactivityWarningDialog;